import intersection from 'lodash-es/intersection';
import isNil from 'lodash-es/isNil';
import { useClient } from '../../../ClientProvider';
import { BillingStatus } from '../../../enums';
import { mergeQueryState } from '../../../mergeState';
import { cumulativeSumMetrics, toFrontEndAccumulationMetric } from '../../../resources/cumulativeSum';
import useQuery from '../../../useQuery';
import { isPlot, isStation } from '../../utils/resourcesTypeCheckers';
const expertOnlyCumulativeSum = ['etp', 'SSI_HOURS'];
const useCumulativeSum = (resource, org) => {
    const client = useClient();
    const { id } = resource;
    const isExpert = !isNil(org) ? org.billingStatus === BillingStatus.expert : false;
    const configRequest = useQuery(client.cumulativeSum.getConfig({
        plotId: isPlot(resource) ? id : undefined,
        stationId: isStation(resource) ? id : undefined
    }));
    const config = configRequest.data;
    const cumulativeSumRequest = useQuery(client.cumulativeSum.result({
        plotId: isPlot(resource) ? id : undefined,
        stationId: isStation(resource) ? id : undefined,
        metrics: configRequest.data?.activated?.map(toFrontEndAccumulationMetric)
    }), { enabled: !configRequest.isLoading });
    const state = mergeQueryState(configRequest, cumulativeSumRequest);
    const cumulativeSum = cumulativeSumRequest.data;
    const availableMeasures = [...resource.availableMeasures];
    if (resource.availableMeasures.includes('T')) {
        availableMeasures.push('COLD_T_HOUR');
    }
    const nonActivatedSums = intersection(availableMeasures, cumulativeSumMetrics).filter((metric) => !config?.activated?.includes(metric));
    let addableCumulativeSums = [...nonActivatedSums];
    if (!isExpert) {
        addableCumulativeSums = nonActivatedSums.filter((metric) => !expertOnlyCumulativeSum.includes(metric));
    }
    return { state, config, cumulativeSum, addableCumulativeSums };
};
export default useCumulativeSum;
